import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import CommonStore from './common/common'
import ElcSgnStore from './common/elcSgnInf'

export default new Vuex.Store({
    modules: {
        common: CommonStore,
        elcSgnInf: ElcSgnStore
    }, 
    plugins: [ 
        createPersistedState({paths: ["elcSgnInf"], storage: window.sessionStorage}),
        createPersistedState({paths: ["common"], storage: window.sessionStorage})
    ]
})